function SvgPostIt(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 19 21" {...props}>
      <path
        d="M16.108 14.936c-1.044 1.156-3.028 2.469-6.67 2.469H.935V3.71h8.503c3.4 0 5.483-1.109 6.67-2.111v13.336zm1.822 2.469h-3.65c1.227-.566 2.075-1.301 2.648-1.972l.017-.025c.009-.012.018-.023.025-.036a.42.42 0 00.04-.082.406.406 0 00.025-.09.42.42 0 00.004-.05l.003-.03V3.712h.888v13.694zM.935 19.883H17.93v-1.527H.935v1.527zM18.397 2.759h-1.355V.475a.464.464 0 00-.819-.314C15.206 1.348 13.2 2.76 9.439 2.76H.468A.472.472 0 000 3.235V20.36c0 .262.21.476.467.476h17.93a.472.472 0 00.467-.476V3.235a.472.472 0 00-.467-.476z"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgPostIt;
